module.exports = __webpack_public_path__ + "static/media/video_HD_compressed.a8a7ace2.mp4";